module.exports = __webpack_public_path__ + "static/media/aboutHero.714c778e.jpg";